import { first, last } from 'lodash';

export type FirstLastNameType = {
  firstName: string;
  lastName: string;
};
export function getFirstNameLastName<T extends FirstLastNameType>(object: T) {
  return `${object?.firstName} ${object?.lastName}`;
}

export const getFirstNameLastInitial = (fullName: string): string => {
  if (!fullName) {
    return '';
  }
  const splitNames = fullName.split(' ');

  return `${first(splitNames)} ${last(splitNames)?.charAt(0).toUpperCase()}.`;
};
